"use client";
import Link from "next/link";
import ProbeMeAI from "@/Component/AI/ProbeMeAI";
import AIcrousel from "@/Component/Aicrousel";

const ProbeMe = () => {
  return (
    <>
      <title>ProbeMe AI</title>
      <meta
        name="keywords"
        content="AI-led ProbeMeis an intelligent moderation platform that enables rich and engaging conversations with participants. Acting as an AI moderator, it actively listens, responds, and asksr elevant follow-up questions based on participant input, ensuring insightful and dynamic interactions. "></meta>
      <meta
        name="description"
        content="ProbeMe AI is an intelligent moderation platform that enables rich and engaging conversations with participants. Acting as an AI moderator, it actively listens, responds, and asks relevant follow-up questions based on participant input, ensuring insightful and dynamic interactions."></meta>

      <section className="padding-left-x  light-gray-bg">
        <div className="container-fluid">
          <div className="data-collection-nav dataCollectionDesktopCarousel">
            <Link
              className="nav-item collection-nav-active"
              href={"/products/AI/probemeai"}>
              ProbeMe AI
            </Link>
            <Link className="nav-item " href={"/products/AI/codemeai"}>
              CodeMe AI
            </Link>
            <Link className="nav-item " href={"/products/AI/datareporter"}>
              Data Reporter AI
            </Link>
            <Link className="nav-item " href={"/products/AI/slidemanager"}>
              SlideManager AI
            </Link>
          </div>
          {/* for mobile */}
          <div className="container-fluid dataCollectionMobileCarousel">
            <AIcrousel activeNav={"probeme"} initialScroll={0} />
          </div>
          {/* End */}
          <div className="tab-content">
            <div className="tab-pane fade show active"></div>
            <ProbeMeAI />
          </div>
        </div>
      </section>
    </>
  );
};

export default ProbeMe;
